import { connect } from 'react-redux'
import Form from './form'
import { getUser } from '../../../../../../stores/user/user.selectors'
import {
  searchSchoolsToRequest,
  cancelPendingTeacherRequest
} from '../../../../../../stores/user/user.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = (state, { me }) => {
  const user = getUser(state)
  return {
    pendingTeacher:
      user.pending_teacher_type &&
      (user.pending_teacher_type.school ||
        user.pending_teacher_type.description) &&
      !user.pending_teacher_type.approved_teacher,
    userId: user && user.id,
    pendingTeacherSchool:
      user.pending_teacher_type &&
      user.pending_teacher_type.school &&
      user.pending_teacher_type.school.title
  }
}

const mapDispatchToProps = dispatch => ({
  onSearchChange: term =>
    dispatch(searchSchoolsToRequest(term)).catch(errorHandler),
  onRemove: userId =>
    dispatch(cancelPendingTeacherRequest(userId)).catch(errorHandler)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form)
